<template>
  <div class="gis-data-export-body">
    <el-row>
      <el-col :span="8" class="tree-col">
        <el-scrollbar style="height: 600px;"
          ref="scrollbar"
        >
          <el-tree
            :data="airTypeData"
            show-checkbox
            node-key="label"
            ref="airTypeTree"
          >
          </el-tree>
        </el-scrollbar>
      </el-col>
      <el-col :span="8">
        <el-date-picker
          v-model="dataTime"
        ></el-date-picker>
      </el-col>
      <el-col :span="8">
        <el-button
          size="small"
          type="primary"
          icon="el-icon-upload2"
          @click="exportFn"
          :loading="exportLoad"
        >导出</el-button>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { aPictureDataType, aPictureDataExport } from './request';

export default {
  // 组件
  components: {},
  // 组件数据
  props: {},
  // 数据
  data() {
    return {
      airTypeData: [],
      dataTime: new Date(),
      exportLoad: false,
    };
  },
  // 组件启动时
  created() {
    this.aPictureDataTypeFn();
  },
  // 组件启动后
  mounted() {},
  computed: {},
  watch: {},
  // 方法块
  methods: {
    exportFn(){
      const airTypeTree = this.$refs['airTypeTree'],
            type = airTypeTree.getCheckedKeys(),
            date = dayjs(this.dataTime).format('YYYY-MM-DD');
      this.exportLoad = true;
      aPictureDataExport({ date, type }).then(res=>{
        if(res.data.code == 1004){
          // 创建Blob对象
          const blob = new Blob([JSON.stringify(res.data.data)], { type: 'text/plain' });
          // 创建下载链接
          const downloadLink = document.createElement('a');
          downloadLink.href = URL.createObjectURL(blob);
          downloadLink.download = `${date}.geojson`;
          // 触发点击事件
          downloadLink.click();
          // 释放URL对象
          setTimeout(() => {
            URL.revokeObjectURL(downloadLink.href);
          }, 100);
        }
        this.exportLoad = false;
      }).catch(err=>{
        this.exportLoad = false;
        console.log(err);
      });
    },
    aPictureDataTypeFn(){
      aPictureDataType({}).then(res=>{
        if(res.data.code == 1004){
          this.airTypeData = res.data.data;
        }
      }).catch(err=>{
        console.log(err);
      });
    }
  },
  // 组件销毁时
  destroyed() {},
};
</script>
<style lang='less'>
</style>
<style lang='less' scoped>
.gis-data-export-body {
  width: 100%;
  height: 100vh;
  padding: 10px;
}
</style>